import { Routes } from '@angular/router';
import { AuthGuardService } from './service/auth.guard.service';
import { LoginGuardService } from './service/login.guard.service';
import { adminGuard } from './service/admin.guard.service';
import { superAdminGuard } from './service/super-admin.guard.service';
import { gdprConsentGuard } from './service/gdpr-consent.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
    canActivate: [LoginGuardService],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
    canActivate: [AuthGuardService],
    children: [
      {
        path: '', // Empty path = default child
        loadComponent: () =>
          import('./pages/dashboard/dashboard-home/dashboard-home').then((m) => m.DashboardHome),
        canActivate: [adminGuard], // ADMIN or SUPER_ADMIN can access Home
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/dashboard/profile/profile').then((m) => m.Profile),
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/dashboard/settings/settings').then((m) => m.Settings),
        canActivate: [superAdminGuard], // SUPER_ADMIN only
      },
      {
        path: 'chat',
        loadComponent: () =>
          import('./pages/dashboard/dashboard-chat/dashboard-chat').then((m) => m.DashboardChat),
      },
    ],
  },
  {
    path: 'contacts',
    loadComponent: () => import('./pages/contacts/contacts').then((m) => m.Contacts),
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/contacts/contacts-home/contacts-home').then((m) => m.ContactsHome),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/contacts/contact-details/contact-details').then((m) => m.ContactDetails),
      },
    ],
  },
  {
    path: 'locations',
    loadComponent: () => import('./pages/locations/locations').then((m) => m.Locations),
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/locations/locations-home/locations-home').then((m) => m.LocationsHome),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/locations/location-details/location-details').then(
            (m) => m.LocationDetails,
          ),
      },
    ],
  },
  {
    path: 'activity',
    loadComponent: () => import('./pages/activity/activity').then((m) => m.Activity),
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/activity/activity-home/activity-home').then((m) => m.ActivityHome),
      },
    ],
  },
  {
    path: 'calendar/event/:id',
    loadComponent: () =>
      import('./pages/calendar/calendar-event-detail/calendar-event-detail').then(
        (m) => m.CalendarEventDetailComponent,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: 'enrichment',
    loadComponent: () =>
      import('./pages/enrichment-client/enrichment-client').then((m) => m.EnrichmentClient),
    canActivate: [AuthGuardService, superAdminGuard, gdprConsentGuard],
  },
  // {
  //   path: 'enrichment-prototype',
  //   loadComponent: () => import('./pages/enrichment-prototype/enrichment-prototype').then(m => m.EnrichmentPrototype),
  //   canActivate: [AuthGuardService, gdprConsentGuard],
  // },
  // {
  //   path: 'connections-prototype',
  //   loadComponent: () => import('./pages/connections-prototype/connections-prototype').then(m => m.ConnectionsPrototype),
  //   canActivate: [AuthGuardService, gdprConsentGuard],
  // },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' },
];
